import useSWR from 'swr'

import { fetchYieldStats } from '../utils/yield'

export default function useYieldAllStats() {
  return useSWR(['YieldAllStats'], fetchYieldStats, { revalidateOnFocus: false })
}
